// A block of consequence in a page — "this is off", "that was refused", "here
// is what happens next". Replaces MUI's `Alert`.
//
// **A left rule and a tinted fill, never an icon and a close button.** An
// `Alert` is a dismissible thing with a severity icon; nothing here is
// dismissible, and the four tones are the language's own colours rather than
// MUI's red/amber/blue/green — there is no green (PLAN-UI §28.2), so `good` is
// cream.

import { styled } from "@mui/material/styles";

export type NoticeTone = "info" | "good" | "warn" | "bad";

export interface NoticeOwnProps {
  tone?: NoticeTone;
}

export const Notice = styled("div", {
  shouldForwardProp: (prop: string) => prop !== "tone"
})<NoticeOwnProps>(({ theme, tone = "info" }) => {
  const c = theme.kit.color;
  const rule = { info: c.line, good: c.cream, warn: c.brand, bad: c.rust }[tone];
  return {
    borderLeft: `4px solid ${rule}`,
    background: `color-mix(in srgb, ${rule} 12%, ${c.panel})`,
    borderRadius: theme.kit.radius.md,
    padding: "10px 14px",
    color: c.ink,
    fontFamily: theme.kit.font.body,
    fontSize: 13.5,
    lineHeight: 1.5
  };
});
